// extracted by mini-css-extract-plugin
export default {"total":"style_total__ntgKp"};